/** Return the calendar date in the browser's local timezone (YYYY-MM-DD). */
export function localDateString(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Format a date for a `datetime-local` input (YYYY-MM-DDTHH:mm:ss, local time). */
export function localInputValue(date: Date): string {
  const shifted = new Date(date.getTime() - date.getTimezoneOffset() * 60_000);
  return shifted.toISOString().slice(0, 19);
}

/** Format a date for a `time` input (HH:mm:ss, local time). */
export function localTimeValue(date: Date): string {
  return localInputValue(date).slice(11);
}

export function startOfDay(date: Date): Date {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
}

export function endOfDay(date: Date): Date {
  const next = new Date(date);
  next.setHours(23, 59, 59, 999);
  return next;
}

export function startOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function addMonths(date: Date, count: number): Date {
  return new Date(date.getFullYear(), date.getMonth() + count, 1);
}

export function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}

/**
 * Return the 6x7 grid of days covering the given month, including the
 * leading/trailing days from adjacent months needed to fill the weeks.
 * Weeks start on Sunday, matching the he-IL calendar.
 */
export function monthGrid(year: number, month: number): Date[] {
  const first = new Date(year, month, 1);
  const gridStart = new Date(year, month, 1 - first.getDay());
  return Array.from({ length: 42 }, (_, index) =>
    new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + index));
}

/** Combine the calendar date of `day` with the time-of-day of `time`. */
export function withTimeOf(day: Date, time: Date): Date {
  const next = new Date(day);
  next.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
  return next;
}
